<template>
  <div class="page-container">
    <div class="head-card">基本信息</div>
    <BaseInfo :info="info"></BaseInfo>
    <div class="head-card">业务信息</div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="140"
    >
      <Row>
        <FormItem label="教师类别：" prop="teacherKind" style="width: 50%">
          <Select
            v-model="formValidate.teacherKind"
            style="width: 300px"
            clearable
            placeholder="请选择教师类别"
          >
            <Option
              :value="key"
              :key="key"
              v-for="(item, key) in teacherKindMap"
              >{{ item }}</Option
            >
          </Select></FormItem
        >
        <FormItem
          label="资格证书名称："
          prop="certificateName"
          style="width: 50%"
        >
          <div class="flex">
            <div style="margin-right: 12px">
              <Input
                v-model="formValidate.certificateName"
                placeholder="请输入证书名称，多个、号隔开"
                style="width: 300px"
              ></Input>
              <p style="padding-top: 12px">
                <Button
                  type="primary"
                  @click="handleCfClick"
                  :disabled="cfImageLen >= 3"
                  >上传证明附件</Button
                >
              </p>
            </div>

            <UploadImage
              :maxNumber="3"
              :showAddBtn="false"
              ref="uploadCfImageRef"
              :disabled="caImageLen >= 3"
              @on-change="onCfImageChange"
            ></UploadImage>
          </div>
        </FormItem>
      </Row>
      <Row>
        <FormItem label="资格证书编号：" style="width: 50%">
          <Input
            v-model="formValidate.certificateCode"
            placeholder="请输入资格证书编号"
            style="width: 300px"
          ></Input>
        </FormItem>
        <FormItem label="可提供的机构证明：" style="width: 50%">
          <div class="flex">
            <div style="margin-right: 12px">
              <Input
                v-model="formValidate.caName"
                placeholder="请输入可提供的机构证明，多个、号隔开"
                style="width: 300px"
              ></Input>
              <p style="padding-top: 12px">
                <Button type="primary" @click="handleCaClick"
                  >上传证明附件</Button
                >
              </p>
            </div>
            <UploadImage
              :maxNumber="3"
              :showAddBtn="false"
              ref="uploadCaImageRef"
              @on-change="onCaImageChange"
            ></UploadImage>
          </div>
        </FormItem>
      </Row>
      <Row>
        <FormItem label="普通话水平等级：" style="width: 50%">
          <Select
            v-model="formValidate.pscLevel"
            style="width: 300px"
            clearable
            placeholder="请选择"
          >
            <Option
              :value="key"
              :key="key"
              v-for="(item, key) in pscLevelMap"
              >{{ item }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="计算机水平等级：" style="width: 50%">
          <Select
            v-model="formValidate.ncreLevel"
            style="width: 300px"
            clearable
            placeholder="请选择"
          >
            <Option
              :value="key"
              :key="key"
              v-for="(item, key) in ncreLevelMap"
              >{{ item }}</Option
            >
          </Select>
        </FormItem>
      </Row>
      <Row>
        <FormItem label="学历：" style="width: 50%">
          <Select
            v-model="formValidate.eduBackground"
            style="width: 300px"
            clearable
            placeholder="请选择学历"
          >
            <Option
              :value="key"
              :key="key"
              v-for="(item, key) in eduBackgroundMap"
              >{{ item }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="毕业学校：" style="width: 50%">
          <Input
            v-model="formValidate.graduateSchool"
            placeholder="请输入毕业学校"
            style="width: 300px"
          ></Input
        ></FormItem>
      </Row>
      <Row>
        <FormItem label="专业：" style="width: 50%">
          <Input
            v-model="formValidate.specialty"
            placeholder="请输入专业名称"
            style="width: 300px"
          ></Input>
        </FormItem>
        <FormItem label="毕业年限：" style="width: 50%">
          <Input
            v-model="formValidate.graduationYears"
            placeholder="请输入毕业年限"
            style="width: 300px"
          ></Input
        ></FormItem>
      </Row>
    </Form>
    <div class="head-card">个人履历</div>
    <div
      id="personalResumeEditor"
      ref="personalResumeEditorRef"
      style="margin-bottom: 20px"
    ></div>
    <div class="head-card">教学成果</div>
    <div
      id="teachAchievementsEditor"
      ref="teachAchievementsEditorRef"
      style="margin-bottom: 20px"
    ></div>
    <div class="head-card">任教课程范围</div>
    <div
      id="teachScopeEditor"
      ref="teachScopeEditorRef"
      style="margin-bottom: 20px"
    ></div>

    <div class="footer-main">
      <div class="flex justify-content" style="margin-left: -22%">
        <Button style="margin-right: 50px" @click="handleCancel('formValidate')"
          >取消</Button
        >
        <Button
          type="primary"
          @click="handleCfm('formValidate')"
          :disabled="info && info['departure'] == 1"
          >保存</Button
        >
      </div>
    </div>
  </div>
</template>

<script>
import E from 'wangeditor';
import BaseInfo from './assets/components/BaseInfo.vue'

import eduTeacherApi from '@/request/eduCenter/teachers.js'
import mixin from './mixins'
import UploadImage from '@c/Base/UploadImage.vue'
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
export default {
  components: {
    BaseInfo,
    UploadImage
  },
  mixins: [mixin],
  data() {
    return {
      teacherExId: this.$route.query.teacherExId,
      info: null,
      formValidate: {
        graduateSchool: '',
        specialty: '',
        graduationYears: '',
        certificateCode: '',
        certificateName: '',
        caName: '',
        certificateAttachment: '',
        caAttachment: '',
        teacherKind: null,
        pscLevel: null,
        eduBackground: null,
        ncreLevel: null
      },
      cfImageLen: 0, // 资格证书图片数
      caImageLen: 0, // 机构证明图片数
      ruleValidate: {
        teacherKind: [
          { required: true, message: '请选择教师类别', trigger: 'change' }
        ],
        certificateName: [
          { required: true, message: '请输入资格证书名称', trigger: 'blur' }
        ],
      },
      personalResumeEditor: null,
      teachAchievementsEditor: null,
      teachScopeEditor: null,

    }
  },
  created() {
    this.getSysTeacherInfo()
  },
  mounted() {

  },
  beforeDestroy() {

  },
  methods: {
    ...mapMutations([
      'CLOSE_BROWSINGHISTORYLIST',
    ]),
    // 获取详情
    async getSysTeacherInfo() {
      this.$Spin.show();
      let res = await eduTeacherApi.getSysTeacherInfo({
        teacherExId: this.teacherExId
      })
      this.$Spin.hide();
      if (res.status == 200) {
        this.info = res.message
        this.fillForm()
        setTimeout(() => {
          this.initE()
        }, 1000)
      }
    },
    fillForm() {
      let checkLabel = ['teacherKind', 'pscLevel', 'ncreLevel', 'eduBackground']
      for (let k in this.formValidate) {
        this.formValidate[k] = checkLabel.includes(k) ? String(this.info[k]) : this.info[k]
      }
      if (this.formValidate.certificateAttachment) {
        let ids = this.formValidate.certificateAttachment.split(',')
        this.cfImageLen = ids.length
        console.log(ids, 'ids')
        this.$refs.uploadCfImageRef.setIds(ids)
      }
      if (this.formValidate.caAttachment) {
        let ids = this.formValidate.caAttachment.split(',')

        this.caImageLen = ids.length
        this.$refs.uploadCaImageRef.setIds(ids)
      }

    },
    initE() {
      ['personalResumeEditor', 'teachAchievementsEditor', 'teachScopeEditor'].forEach(item => {
        this[item] = new E(`#${item}`);
        // 这里各位小伙伴可以查询官网，根据自己的需求进行菜单栏调整
        this[item].config.menus = [
          'head', // 标题
          'bold', // 粗体
          'fontSize', // 字号
          'fontName', // 字体
          'italic', // 斜体
          'foreColor', // 文字颜色
          'list', // 列表
          'justify' // 对齐方式
        ];

        this[item].create();
        this.setEditorContext(item)

      })
    },

    // 处理富文本编辑器的内容
    setEditorContext(item, html) {
      let map = {
        'personalResumeEditor': 'personalResume',
        'teachAchievementsEditor': 'teachAchievements',
        'teachScopeEditor': 'teachScope',
      }
      this[item].txt.html(this.info[map[item]])
    },
    handleCfm(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.updateSysTeacher()
        } else {
          this.checkParameter()
        }
      })
    },
    handleCancel() {
      this.$router.go(-1)
    },
    handleCfClick() {
      this.$refs.uploadCfImageRef.handleClickBtn()
    },
    handleCaClick() {
      this.$refs.uploadCaImageRef.handleClickBtn()
    },
    // 检查必填参数
    checkParameter() {
      if (!this.formValidate.teacherKind) {
        this.$Message.warning('请选择教师类别');
        return null
      }
      if (!this.formValidate.certificateName) {
        this.$Message.warning('请输入资格证书名称');
        return null
      }
    },
    async getParameter() {

      return new Promise(async (resolve, reject) => {
        let cfIds = await this.$refs.uploadCfImageRef.getResult()
        let caIds = await this.$refs.uploadCaImageRef.getResult()
        this.formValidate.certificateAttachment = cfIds.join(',')
        this.formValidate.caAttachment = caIds.join(',')
        this.formValidate.teachAchievements = this.teachAchievementsEditor.txt.html()
        this.formValidate.teachScope = this.teachScopeEditor.txt.html()
        this.formValidate.personalResume = this.personalResumeEditor.txt.html()
        let data = {
          ...this.info,
          ...this.formValidate
        }

        resolve({
          teacherExId: this.teacherExId,
          ...data
        })
      })


    },
    async updateSysTeacher() {
      let parameter = await this.getParameter()
      if (!parameter) { return null }
      let res = await eduTeacherApi.updateSysTeacher(parameter)
      if (res.status == 200) {
        this.$Message.success('修改成功');
        this.CLOSE_BROWSINGHISTORYLIST(this.$route.name)
        this.$router.push({
          name: 'eduCenter_teachers_details',
          query: {
            teacherExId: this.teacherExId
          }
        });
      }
    },
    // 
    onCfImageChange(list) {
      this.cfImageLen = list.length
    },
    //
    onCaImageChange(list) {
      this.caImageLen = list.length
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  background-color: #fff;
  width: 100%;
  height: 100%;
  padding: 20px 20px 100px;
  .head-card {
    background: rgb(247, 248, 250);
    height: 40px;
    padding-left: 20px;
    line-height: 40px;
    font-weight: 600;
    border-radius: 8px;
    margin-bottom: 20px;
  }
  /deep/ .ivu-form-item {
    margin-bottom: 22px !important;
  }
  .footer-main {
    position: fixed;
    bottom: 0;

    width: 110%;
    background-color: #fff;
    z-index: 99999;
    padding: 20px 0;
    border-top: 1px solid #eee;
  }
}
</style>